/**
 * AUTO-GENERATED — DO NOT EDIT.
 * Source: sdk.manifest.yml + openapi.json.
 * Regenerate with: pnpm gen
 */

import { createMutationHook } from '../../core/factories/createMutation.js';
import type { AddThesisReplyResponse, AddThesisReplyVars } from '../openapi-types.gen.js';

export type { AddThesisReplyResponse, AddThesisReplyVars } from '../openapi-types.gen.js';

export const useAddThesisReply = createMutationHook<AddThesisReplyVars, AddThesisReplyResponse, unknown>({
  specName: 'useAddThesisReply',
  path: '/v1/theses/{signature}/reply',
  method: 'POST',
  resolveUrl: (vars: AddThesisReplyVars) => `/v1/theses/${vars.signature}/reply`,
  buildBody: (vars: AddThesisReplyVars) => ({ content: vars.content }),
  parseResponse: (raw: unknown): AddThesisReplyResponse => raw as AddThesisReplyResponse,
  optimistic: [{
    queryKey: ['theses', 'detail'],
    apply: (prev: any, vars: AddThesisReplyVars) => {
      if (prev === undefined) return prev;
      let next: any = prev;
      return next;
    },
  }],
  
  
});
